// LandPrepPopup.jsx

import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  IconButton,
  Grid,
  Typography,
  InputLabel,
  TextField,
  Tabs,
  Tab,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@mui/styles";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import DatePicker from "react-datepicker";
import CustomButton from "../../Custom/CustomButton";
import instance from "../../../globals/axios";
import { getFarmerPlotId } from "../../../globals/utils";
import { useAlert } from "../../Alert";
import axios from "axios";
import { getAuth } from "../../../globals/authentication";
import { SERVER_BASE_ADDRESS } from "../../../globals/const";
import SuccessPopup from "./SuccessPopup";

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
    fontSize: 16,
  },
  dialogContent: {
    height: 400,
  },
  datepicker: {
    display: "none",
  },
  taxtLabel: {
    fontSize: "12px !important",
    fontFamily: "Inter",
    fontWeight: "400 !important",
    color: "#000",
    marginTop: "10px",
  },
  taxtTitle: {
    fontSize: "12px !important",
    fontFamily: "Inter",
    fontWeight: "700 !important",
    color: "#000",
  },
  popup: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 9999,
  },
  popupContent: {
    backgroundColor: "#fff",
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    display: "flex",
    alignItems: "center",
  },
  popupText: {
    marginLeft: theme.spacing(2),
  },
}));

const CropHealthPopup = ({ onClose, t }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [imagesPerTab, setImagesPerTab] = useState([[], [], []]);
  const [datesPerTab, setDatesPerTab] = useState([null, null, null]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [existingData, setExistingData] = useState(null);
  const [fullImage, setFullImage] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);
  const [tabAccess, setTabAccess] = useState([false, false, false]);
  const { showAlert } = useAlert();
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [dateErrors, setDateErrors] = useState(["", "", ""]);
  const [imageErrors, setImageErrors] = useState(["", "", ""]);
  const [loading, setLoading] = useState(false);
  let farmerPlotId = getFarmerPlotId();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await instance.get(
          `plotengagement/get-booking?farmer_plot=${farmerPlotId}`
        );
        const data = response.data;
        const enabledTabs = Array(3).fill(false);
        setExistingData(data);
        data.forEach((item) => {
          enabledTabs[item.stage - 1] = true;
        });
        if (enabledTabs[1] && !enabledTabs[2]) {
          enabledTabs[2] = true;
        }
        if (enabledTabs[0] && !enabledTabs[1]) {
          enabledTabs[1] = true;
        }
        setTabAccess(enabledTabs);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (farmerPlotId) {
      fetchData();
    }
  }, [farmerPlotId]);
  useEffect(() => {
    if (existingData) {
      const updatedDates = [...datesPerTab];
      const updatedImages = [...imagesPerTab];

      existingData.forEach((data) => {
        const tabIdx = data.stage - 1;
        updatedDates[tabIdx] = new Date(data.booking_date);
        updatedImages[tabIdx] = data.uploaded_files.map((file) => file.URL);
      });

      setDatesPerTab(updatedDates);
      setImagesPerTab(updatedImages);
    }
  }, [existingData, selectedTab]);
  const validateForm = () => {
    let isFormValid = true;
    const updatedDateErrors = [...dateErrors];
    const updatedImageErrors = [...imageErrors];

    if (!datesPerTab[selectedTab]) {
      updatedDateErrors[selectedTab] = "Please select a date.";
      isFormValid = false;
    } else {
      updatedDateErrors[selectedTab] = "";
    }

    if (imagesPerTab[selectedTab].length === 0) {
      updatedImageErrors[selectedTab] = "Please upload at least one image.";
      isFormValid = false;
    } else {
      updatedImageErrors[selectedTab] = "";
    }

    setDateErrors(updatedDateErrors);
    setImageErrors(updatedImageErrors);

    return isFormValid;
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files).slice(
      0,
      3 - imagesPerTab[selectedTab].length
    );
    const fileObjects = files.map((file) => {
      const blobURL = URL.createObjectURL(file);
      return { blobURL, name: file.name };
    });

    setImagesPerTab((prevImages) => {
      const updatedImages = [...prevImages];
      const existingImages = updatedImages[selectedTab];
      const filteredFiles = fileObjects.filter(
        (fileObj) => !existingImages.includes(fileObj)
      );
      updatedImages[selectedTab] = [...existingImages, ...filteredFiles];
      return updatedImages;
    });
    setImageErrors((prevErrors) => {
      const updatedErrors = [...prevErrors];
      updatedErrors[selectedTab] = "";
      return updatedErrors;
    });
  };
  const handleDateChange = (date) => {
    setDatesPerTab((prevDates) => {
      const updatedDates = [...prevDates];
      updatedDates[selectedTab] = date;
      return updatedDates;
    });
    setDateErrors((prevErrors) => {
      const updatedErrors = [...prevErrors];
      updatedErrors[selectedTab] = "";
      return updatedErrors;
    });
  };
  const handleDeleteImage = (tabIndex, imageIndex) => {
    const updatedImagesPerTab = [...imagesPerTab];
    updatedImagesPerTab[tabIndex] = updatedImagesPerTab[tabIndex].filter(
      (_, index) => index !== imageIndex
    );
    setImagesPerTab(updatedImagesPerTab);
    const inputElement = document.getElementById("image-upload");
    if (inputElement) {
      inputElement.value = "";
    }
  };
  const handleImageClick = (image) => {
    setFullImage(image);
  };
  const handleCloseFullImage = () => {
    setFullImage(null);
  };
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    setSelectedDate(datesPerTab[newValue]);
    for (let i = 0; i < imagesPerTab.length; i++) {
      if (i !== newValue) {
        setImagesPerTab((prevImages) => {
          const updatedImages = [...prevImages];
          updatedImages[i] = [];
          return updatedImages;
        });
      }
    }
  };
  const blobToFile = async (blobUrl, fileName) => {
    const response = await fetch(blobUrl);
    const blob = await response.blob();
    return new File([blob], fileName, { type: blob.type });
  };

  const handleSubmit = async () => {
    const isFormValid = validateForm();
    if (isFormValid) {
      const formatDate = (date) => {
        const pad = (num) => (num < 10 ? `0${num}` : `${num}`);
        return date
          ? `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
              date.getDate()
            )}`
          : null;
      };
      setLoading(true);
      const formData = new FormData();
      let token = getAuth().token;
      const headers = {
        Authorization: `Token ${token}`,
        "Content-Type": "multipart/form-data",
      };
      let date = formatDate(datesPerTab[selectedTab]);
      formData.append("farmer_plot", farmerPlotId);
      formData.append("booking_date", date);
      formData.append("stage", String(selectedTab + 1));
      const selectedImages = imagesPerTab[selectedTab];

      for (let index = 0; index < selectedImages.length; index++) {
        const { blobURL, name } = selectedImages[index];
        const file = await blobToFile(blobURL, name);
        formData.append(`img${index + 1}`, file);
      }

      const apiUrl = "plotengagement/create-booking";
      axios
        .post(`${SERVER_BASE_ADDRESS}/${apiUrl}`, formData, {
          headers,
        })
        .then((res) => {
          if (res?.data) {
            setShowSuccessPopup(true);
            setTimeout(() => {
              setShowSuccessPopup(false);
              onClose();
            }, 2000);
          }
        })
        .catch((err) => {
          console.error("Error:", err);
          setLoading(false);
          showAlert("error", "Some Error Occured");
        });
    }
  };
  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="xs"
        style={{ zIndex: 1 }}
        PaperProps={{ style: { maxHeight: "calc(100% - 25%)" } }}
      >
        <div style={{ padding: "16px", maxHeight: "400px" }}>
          <Grid container>
            <Grid item xs={10}>
              <DialogTitle
                style={{ padding: "0px", fontSize: "14px", fontWeight: 700 }}
              >
                {t("Book here to check crop health")}
              </DialogTitle>
            </Grid>
            <Grid item xs={2}>
              <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={handleClose}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
            <Tabs value={selectedTab} onChange={handleTabChange}>
              <Tab
                label={
                  <Typography style={{ fontSize: "12px" }}>
                    {t("Stage")} 1 <br />
                    20-25 Days
                  </Typography>
                }
                disabled={!tabAccess[0]}
              />
              <Tab
                label={
                  <Typography style={{ fontSize: "12px" }}>
                    {t("Stage")} 2 <br />
                    35-45 Days
                  </Typography>
                }
                disabled={!tabAccess[1]}
              />
              <Tab
                label={
                  <Typography style={{ fontSize: "12px" }}>
                    {t("Stage")}Stage 3 <br />
                    60-70 Days
                  </Typography>
                }
                disabled={!tabAccess[2]}
              />
            </Tabs>
            <div>
              <Grid container>
                <Grid item xs={7} style={{ marginTop: "20px" }}>
                  <InputLabel style={{ fontSize: "12px" }}>
                    {t("Book your date")}
                  </InputLabel>
                </Grid>

                <Grid item xs={5}>
                  <TextField
                    placeholder="DD/MM/YYYY"
                    fullWidth
                    value={
                      datesPerTab[selectedTab]
                        ? datesPerTab[selectedTab].toLocaleDateString()
                        : ""
                    }
                    // disabled={!isEditMode && existingData !== null}
                    disabled={existingData && existingData[selectedTab]}
                    error={!!dateErrors[selectedTab]}
                    helperText={dateErrors[selectedTab]}
                    InputProps={{
                      sx: {
                        height: "40px",
                        borderRadius: "5px",
                        marginTop: "10px",
                        background: "#FFF",
                        border: "1px solid #C7BDBD",
                      },
                      readOnly: true,
                      onClick: () =>
                        document.getElementById("date-picker").click(),
                    }}
                  />
                </Grid>
                <DatePicker
                  id="date-picker"
                  dateFormat="dd/MM/yyyy"
                  selected={selectedDate}
                  onChange={handleDateChange}
                  className={classes.datepicker}
                />
              </Grid>

              <div>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography style={{ fontWeight: 700, fontSize: "14px" }}>
                      {t("Upload Crop leave Image")}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} style={{ marginTop: "10px" }}>
                    <Typography style={{ fontSize: "14px" }}>
                      {t("Gallery")}
                    </Typography>
                  </Grid>
                  <Grid item xs={2} style={{ marginTop: "10px" }}>
                    <React.Fragment>
                      <input
                        type="file"
                        accept="image/jpeg, image/png"
                        onChange={handleImageUpload}
                        multiple
                        style={{ display: "none" }}
                        id="image-upload"
                      />
                      <label htmlFor="image-upload">
                        {existingData && !existingData[selectedTab] ? (
                          <CameraAltIcon />
                        ) : null}
                      </label>
                    </React.Fragment>
                  </Grid>
                  <Grid container spacing={2} style={{ marginTop: "20px" }}>
                    {imagesPerTab[selectedTab].map((imageData, index) => (
                      <Grid key={index} item xs={4}>
                        <div style={{ position: "relative" }}>
                          {existingData && !existingData[selectedTab] ? (
                            <IconButton
                              aria-label="close"
                              onClick={() =>
                                handleDeleteImage(selectedTab, index)
                              }
                              style={{
                                position: "absolute",
                                top: 0,
                                right: 0,
                                zIndex: 1,
                              }}
                            >
                              <CloseIcon />
                            </IconButton>
                          ) : null}

                          {/* <img
														src={image.blobURL}
														alt={`${index.name}`}
														style={{
															width: "100%",
															height: "auto",
															cursor: "pointer",
														}}
														onClick={() => handleImageClick(image)}
													/> */}
                          {typeof imageData === "string" ? (
                            // Render if imageData is a string (external URL)
                            <img
                              src={imageData}
                              alt={`External Image ${index}`} // Alt text for external images
                              style={{
                                width: "100%",
                                height: "auto",
                                cursor: "pointer",
                              }}
                              onClick={() => handleImageClick(imageData)}
                            />
                          ) : (
                            <>
                              <img
                                src={imageData.blobURL}
                                alt={`${imageData.name}`}
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleImageClick(imageData)}
                              />
                            </>
                          )}
                        </div>
                      </Grid>
                    ))}
                    {imageErrors[selectedTab] && (
                      <Typography variant="body2" color="error">
                        {imageErrors[selectedTab]}
                      </Typography>
                    )}
                  </Grid>
                  <Dialog
                    open={Boolean(fullImage)}
                    onClose={handleCloseFullImage}
                    maxWidth="lg"
                  >
                    <Grid container justifyContent="flex-end">
                      <IconButton
                        aria-label="close"
                        onClick={handleCloseFullImage}
                        style={{ position: "absolute", top: 0, right: 0 }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Grid>
                    <img
                      src={fullImage}
                      alt="image"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "80vh",
                        margin: "auto",
                        display: "block",
                      }}
                    />
                  </Dialog>
                </Grid>
              </div>
            </div>
          </Grid>
          <div
            style={{
              display: "flex",
              margin: "auto",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                margin: "auto",
                justifyContent: "center",
              }}
            >
              {existingData && !existingData[selectedTab] ? (
                <div style={{ width: "140px" }}>
                  <CustomButton onClick={handleSubmit} hideIcon>
                    {t("Submit")}
                  </CustomButton>
                </div>
              ) : null}
            </div>
          </div>
        </div>
        {loading && (
          <div className={classes.popup}>
            <div className={classes.popupContent}>
              <CircularProgress size={24} />
              <Typography variant="body1" className={classes.popupText}>
                {t("Submitting")}...
              </Typography>
            </div>
          </div>
        )}
        {showSuccessPopup && (
          <SuccessPopup onClose={() => setShowSuccessPopup(false)} />
        )}
      </Dialog>
    </div>
  );
};

export default CropHealthPopup;
